// extracted by mini-css-extract-plugin
export default {"container":"cR-z","title":"dR-z","link":"eR-z"};